import Crud from "../components/Theme/Crud.vue";
import Add from "../components/Theme/Add.vue";
import Edit from "../components/Theme/Edit.vue";

let routes = {
    path: "/themes",
    component: resolve => require(["../components/layout/App"], resolve),
    children: [
        {
            path: "/themes",
            name: "Temas",
            component: Crud
        },
        {
            path: "/themes/add",
            name: "Nova Tema",
            component: Add
        },
        {
            path: "/themes/edit/:id",
            name: "Editar Tema",
            component: Edit
        }
    ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/theme.js